let Idea = {
	count: 0,
	max: 0
}
let ideas = [];
let ideaSlide = {
	init: function(){
		ideas = [];
		$(".scroll_ideas").each(function(i){
			let _i = object(Idea);
			_i.count = 0;
			_i.max = $(this).find("li.idea").length-2;
			ideas.push(_i);
		});
		ideaSlide.move();
		ideaSlide.nav();
	},
	nav: function(){
		$(".scroll_ideas").each(function(i){
			let index = i;
			$(this).find("a.btn_idea_prev").off().on("click", function(){
				ideaSlide.dec(index);
			});
			$(this).find("a.btn_idea_next").off().on("click", function(){
				ideaSlide.inc(index);
			});
		});
	},
	inc: function(index){
		ideas[index].count++;
		if(ideas[index].count >= ideas[index].max){
			ideas[index].count = ideas[index].max - 1;
		}else{
			ideaSlide.move(index);
		}
	},
	dec: function(index){
		ideas[index].count--;
		if(ideas[index].count < 0){
			ideas[index].count = 0;
		}else{
			ideaSlide.move(index);
		}
	},
	move: function(index){
		//console.log(index, ideas);
		if(isSmallScreen){
			$(".scroll_ideas").each(function(i){
				let $block = $(this).find("ul.ideas");
				$block.css({
					"transform": `translate3d(0,0,0)`
				});
			});
		}else{
			$(".scroll_ideas").each(function(i){
				let $block = $(this).find("ul.ideas");
				let posX = ideas[i].count * -( $(this).find("ul.ideas li.idea").width() + parseInt( $(this).find("ul.ideas li.idea").css("margin-right").replace("px", "") )*2 );
				$block.css({
					"transform": `translate3d(${posX}px,0,0)`
				});
				if( ideas[i].count >= ideas[i].max-1 ){
					$(this).find("a.btn_idea_next").css("display", "none");
					$(this).find("a.btn_idea_prev").css("display", "block");
				}else if( ideas[i].count <= 0 ){
					$(this).find("a.btn_idea_next").css("display", "block");
					$(this).find("a.btn_idea_prev").css("display", "none");
				}else{
					$(this).find("a.btn_idea_next").css("display", "block");
					$(this).find("a.btn_idea_prev").css("display", "block");
				}
			});
		}
		
	}
}